import type { FC, FormEventHandler } from 'react';
import { useEffect, useState } from 'react';
import { aboutEmail } from '@images';
import { OldInput } from '../Input';
import Picture from '../Picture';
import { validationEmail } from '@utils/validation';
import API from '@api';
import SuccessModalWithTimer from '@components/Modals/SuccessModalWithTimer';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { useStores } from '@root/src/stores';
import './EmailBanner.scss';

const EmailBanner: FC = observer(() => {
  const { userStore } = useStores();
  const [emailInput, setEmailInput] = useState({
    value: '',
    error: ''
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const getInputData = ({ value }): void => {
    setEmailInput({
      value,
      error: ''
    });
  };
  const [successModalText, setSuccessModalText] = useState('');

  useEffect(() => {
    const disposer = autorun(() => {
      const { user } = userStore;
      setEmailInput({ value: user?.email || '', error: '' });
    });
    return () => {
      if (disposer) {
        disposer();
      }
    };
  }, [userStore]);

  const addSubscriber = (): void => {
    let error = '';

    if (!validationEmail(emailInput.value)) {
      error = 'Некорректный email';
    }
    setEmailInput(prev => ({ ...prev, error }));

    if (error) {
      return;
    }

    API.addSubscriberTemp({ subscribeEmail: emailInput.value }).then(res => {
      setEmailInput({ value: '', error: '' });
      setSuccessModalText(
        res.addSubscriberTemp.result
          ? 'Вы успешно подписались!'
          : 'Вы уже подписаны!'
      );
      setShowSuccessModal(true);
    });
  };

  const closeSuccessModal = (): void => {
    setShowSuccessModal(false);
  };

  const onSubmit: FormEventHandler = e => {
    e.preventDefault();
    addSubscriber();
  };
  return (
    <div className='email-banner'>
      {showSuccessModal && (
        <SuccessModalWithTimer
          closeModal={closeSuccessModal}
          title='Внимание!'
          text={successModalText}
        />
      )}
      <Picture
        className='email-banner__img'
        icon={aboutEmail}
        height='390px'
        width='473px'
      />
      <div className='email-banner__title'>Доставка бесплатно</div>
      <div className='email-banner__text'>
        Бесплатная доставка <br />
        за подписку на новости
      </div>
      <form onSubmit={onSubmit} className='email-banner__input-wrapper'>
        <OldInput
          className='email-banner__input'
          placeholder='E-mail'
          getInputData={getInputData}
          field='text'
          name='text'
          value={emailInput.value}
          error={emailInput.error}
        />
        <button type='submit' className='email-banner__btn'>
          Подписаться
        </button>
      </form>
    </div>
  );
});

export default EmailBanner;
